module.exports = __webpack_public_path__ + "img/tanks.7f64b3d7.png";